import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function Governance() {
  const { t } = useLang();
  const c = t.governance;
  return (
    <section data-testid="governance-section" className="py-24 sm:py-32 bg-ivory-pure border-t border-border">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section text-olive">
            {c.title}
          </Reveal>
          <Reveal className="col-span-12 lg:col-span-8 lg:col-start-4">
            <p className="text-lg text-olive-soft leading-relaxed">{c.intro}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-border">
          {c.steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 70} data-testid={`governance-step-${i}`} className="bg-ivory p-8">
              <div className="big-num text-7xl text-terracotta mb-5">{s.n}</div>
              <h3 className="font-display text-2xl text-olive mb-3 leading-tight">{s.title}</h3>
              <p className="text-olive-soft text-base leading-relaxed">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
